module.exports = __webpack_public_path__ + "static/img/bg.c72cf69.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bg.jpg
// module id = Lr6H
// module chunks = 1